import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { notificationsCacheKey } from "./constants";
import type { CompanyNotificationPreferencesPayload } from "./types";

export const getCompanyNotificationPreferences = reactQueryFetcherAdapter(
  notificationsCacheKey,
  async (signal, companyId: string): Promise<CompanyNotificationPreferencesPayload> => {
    return fetch(`/companies/${companyId}/notification_preferences/list`, "GET", undefined, { signal });
  }
);
